import { Values } from '@app-evolution-cms/element-ui';

export const ENVIRONMENT = {
  development: 'dev',
  stage: 'stg',
  production: 'prd',
} as const;

export type EnvironmentType = Values<typeof ENVIRONMENT>;
